const axios = require('axios');

var axiosInstanceBirthdays = process.env.NODE_ENV === 'production' ? axios.create({
  baseURL: 'https://slackbirthdays.ricotta.team'
}) : 
axios.create({
  baseURL: 'http://localhost:3000/'
})




module.exports = axiosInstanceBirthdays;

